var render, staticRenderFns
import script from "./FormTableBaseKeyHelper.vue?vue&type=script&lang=js"
export * from "./FormTableBaseKeyHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fa7e1c",
  null
  
)

export default component.exports